export default __webpack_public_path__ + "static/media/layout_dark_v2_info_funcstack.72a9bfd2.svg";